import { cn } from '../../lib/cn';
import type { AgentRow } from '../../automationstudio/framework';

type Props = { agents?: AgentRow[] };

export function AIAgentLibraryPanel({ agents = [] }: Props) {
  return (
    <div className="space-y-2">
      {agents.map((a) => (
        <div key={a.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{a.name}</p>
            <p className="mt-0.5 text-xs text-slate-500">{a.type} · {a.tasks.toLocaleString()} tasks</p>
          </div>
          <div className="shrink-0 text-right">
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              a.status === 'active' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
            )}>
              {a.status}
            </span>
            <p className="mt-1 text-xs text-slate-500">{a.success}% success</p>
          </div>
        </div>
      ))}
    </div>
  );
}
